import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "loading", "refetch"];
import { registerQuery, useQuery } from 'data-fetching-client';
import quickFetch from 'quick-fetch';
import { useRefetchOnWindowFocus } from '../utils/useRefetchOnWindowFocus';
import { api } from '../utils/api';
import { FORM_DATA_PATH, PREVIEW_FORM_DATA_PATH } from '../../api/paths';
import { getIsPreview } from '../utils/isPreview';
import { FORM_DATA_EARLY_KEY } from '../constants/earlyRequestKeys';
const GET_FORM_DATA_KEY = 'getFormData';
const fetchFormDataFallback = async () => {
  const {
    isPreview
  } = getIsPreview();
  const path = isPreview ? PREVIEW_FORM_DATA_PATH : FORM_DATA_PATH;
  const response = await api(path);
  return response.json();
};
const fetchFormDataWithEarlyRequest = () => {
  const {
    isPreview
  } = getIsPreview();
  if (!isPreview) {
    const earlyRequest = quickFetch.getRequestStateByName(FORM_DATA_EARLY_KEY);
    if (earlyRequest) {
      return new Promise((resolve, reject) => {
        earlyRequest.whenFinished(data => {
          quickFetch.removeEarlyRequest(FORM_DATA_EARLY_KEY);
          resolve(data);
        });
        earlyRequest.onError(() => {
          quickFetch.removeEarlyRequest(FORM_DATA_EARLY_KEY);
          fetchFormDataFallback().then(resolve).catch(reject);
        });
      });
    }
  }
  return fetchFormDataFallback();
};
const GET_FORM_DATA = registerQuery({
  fieldName: GET_FORM_DATA_KEY,
  fetcher: fetchFormDataWithEarlyRequest
});
export const useFormData = () => {
  const _useQuery = useQuery(GET_FORM_DATA),
    {
      data,
      loading,
      refetch
    } = _useQuery,
    rest = _objectWithoutPropertiesLoose(_useQuery, _excluded);
  useRefetchOnWindowFocus({
    refetch,
    loading
  });
  return Object.assign({
    data: data === null || data === void 0 ? void 0 : data[GET_FORM_DATA_KEY],
    refetch,
    loading
  }, rest);
};